import React from "react";
import { PiChartLineDownBold } from "react-icons/pi";
import { BsGraphUpArrow } from "react-icons/bs";
import { formatToIndianNumber } from "../../../utilities";

export default function ProfitLossCard({
  currentMonth,
  previousMonth,
  isExpense = false,
}) {
  const thisMonth = Number(currentMonth) || 0;
  const lastMonth = Number(previousMonth) || 0;

  let percentageChange = 0;
  let status = "No Change";
  let isProfit = null;

  if (lastMonth === 0 && thisMonth === 0) {
    percentageChange = 0;
    status = "No Change";
  } else if (lastMonth === 0 && thisMonth > 0) {
    percentageChange = 100;
    status = isExpense ? "Loss" : "Profit";
    isProfit = !isExpense;
  } else if (lastMonth > 0 && thisMonth === 0) {
    percentageChange = 100;
    status = isExpense ? "Profit" : "Loss";
    isProfit = isExpense;
  } else {
    percentageChange = ((thisMonth - lastMonth) / lastMonth) * 100;
    if (isExpense) {
      isProfit = percentageChange < 0;
    } else {
      isProfit = percentageChange > 0;
    }

    status = isProfit ? "Profit" : "Loss";
  }

  return (
    <div className="mt-3">
      <div
        className="card rounded-3"
        style={{
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div className="card-body p-2">
          <div className="d-flex justify-content-between align-items-center">
            <div className="text-center flex-fill border-end">
              <span
                className="d-block text-dark"
                style={{ fontSize: "0.65rem" }}
              >
                Last Month
              </span>
              <span
                className="fw-semibold text-darker"
                style={{ fontSize: "0.8rem" }}
              >
                ₹{formatToIndianNumber(lastMonth)}
              </span>
            </div>
            <div className="text-center flex-fill border-end">
              <span
                className="d-block text-dark"
                style={{ fontSize: "0.75rem" }}
              >
                This Month
              </span>
              <span
                className="fw-semibold text-darker"
                style={{ fontSize: "0.85rem" }}
              >
                ₹{formatToIndianNumber(thisMonth)}
              </span>
            </div>
            <div className="text-center flex-fill">
              <span
                className="d-block text-dark"
                style={{ fontSize: "0.75rem" }}
              >
                {status}
              </span>
              <span
                className="fw-bold d-flex align-items-center justify-content-center"
                style={{
                  fontSize: "0.85rem",
                  color:
                    isProfit === null
                      ? "#aaa"
                      : isProfit
                      ? "#28a745"
                      : "#dc3545",
                }}
              >
                {isProfit === null ? (
                  "–"
                ) : isProfit ? (
                  <>
                    <BsGraphUpArrow size="12" className="me-1" />+
                    {Math.abs(percentageChange).toFixed(2)}%
                  </>
                ) : (
                  <>
                    <PiChartLineDownBold size="13" className="me-1" />
                    {Math.abs(percentageChange).toFixed(2)}%
                  </>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
